import { useEffect, useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { SnapshotFn } from '~/firebase/listeners/type';
import { FirebaseDataStatus } from '~/types/utilities';
import globalEnterpriseGroupBuyAtom from '~/recoil/atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';
import { EnterpriseGroupBuy } from '~/types/enterpriseGroupBuy';
import { enterpriseGroupBuyDataListener } from '~/firebase/listeners/enterpriseGroupBuyData';

export default function useEnterpriseGroupBuyData(enterpriseGroupBuyId: string) {
  const [globalEnterpriseGroupBuyData, setGlobalEnterpriseGroupBuyData] = useRecoilState(
    globalEnterpriseGroupBuyAtom,
  );

  const handleSnapShot = useCallback<SnapshotFn>((doc) => {
    const data = doc.data() as EnterpriseGroupBuy | undefined;

    if (!doc.exists() || !data) {
      setGlobalEnterpriseGroupBuyData((prev) => ({
        ...prev,
        cart: FirebaseDataStatus.NOT_EXIST,
        data: null,
      }));
      return;
    }
    setGlobalEnterpriseGroupBuyData((prev) => ({
      ...prev,
      cart: FirebaseDataStatus.EXIST,
      data: { ...data, id: doc.id },
    }));
  }, []);

  useEffect(() => {
    if (enterpriseGroupBuyId) {
      const unlisten = enterpriseGroupBuyDataListener(enterpriseGroupBuyId, handleSnapShot);

      return () => {
        unlisten();
      };
    }
  }, [enterpriseGroupBuyId]);

  return globalEnterpriseGroupBuyData;
}
